import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function ControlButtons({ formId, onClickBack, onClickNext, isFirstStep, isLastStep, canClickNext, canClickBack }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');

  return (
    <div className={classes.controlButtons}>
      {!isFirstStep && (
        <Button onClick={onClickBack} variant="outlined" color="primary" disabled={!canClickBack}>
          {t('back')}
        </Button>
      )}
      {formId ? (
        <Button type="submit" form={formId} variant="contained" color="primary" className={classes.button} disabled={!canClickNext}>
          {!isLastStep ? t('next') : t('submit')}
        </Button>
      ) : (
        <Button onClick={onClickNext} variant="contained" color="primary" className={classes.button} disabled={!canClickNext}>
          {!isLastStep ? t('next') : t('submit')}
        </Button>
      )}
    </div>
  );
}

ControlButtons.propTypes = {
  formId: PropTypes.string,
  onClickBack: PropTypes.func.isRequired,
  onClickNext: PropTypes.func.isRequired,
  canClickNext: PropTypes.bool.isRequired,
  canClickBack: PropTypes.bool.isRequired,
  isFirstStep: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired,
};

ControlButtons.defaultProps = {
  formId: null,
};

export default ControlButtons;
